import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

const ProductOptions = () => {
  const navigate = useHistory()
  var GetAuth = localStorage.getItem("authUser")
  var TokenJson = JSON.parse(GetAuth)
  var TokenData = TokenJson.token

  const [show, setshow] = useState(false)
  const [show1, setshow1] = useState(false)

  const [Data, setData] = useState([])

  useEffect(() => {
    Get()
  }, [])

  const Get = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetVariationOptions,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setData(res.data.variationoptions)
      })
  }

  const SearchData = e => {
    const myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
    const token = TokenData
    axios
      .post(
        URLS.GetVariationOptionsSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setData(res.data.variationoptions)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const [Category, setCategory] = useState([])

  useEffect(() => {
    GetCategory()
  }, [])

  const GetCategory = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetVariation,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCategory(res.data.variations)
      })
  }

  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const pagesVisited = pageNumber * listPerPage
  const lists = Data.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Data.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const [form, setform] = useState({
    name: "",
    variationId: "",
  })

  const AddPopUp = () => {
    setshow(!show)
    setshow1(false)
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const FormAddSubmit = e => {
    e.preventDefault()
    AddData()
  }

  const AddData = () => {
    var token = TokenData
    const dataArray = {
      name: form.name,
      variationId: form.variationId,
    }

    axios
      .post(URLS.AddVariationOptions, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setshow(false)
            Get()
            setform({
              name: "",
              variationId: "",
            })
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const [form1, setform1] = useState([])

  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  const UpdatePopUp = data => {
    setform1(data)
    setshow(false)
    setshow1(true)
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  const FormEditSubmit = e => {
    e.preventDefault()
    UpdateData()
  }

  const UpdateData = () => {
    var token = TokenData

    const dataArray = {
      name: form1.name,
      variationId: form1.variationId,
    }

    axios
      .put(URLS.EditVariationOptions + form1._id, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setshow1(false)
            Get()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const DeleteData = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = data => {
    var token = TokenData
    var remid = data._id
    axios
      .delete(URLS.DeleteVariationOptions + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            Get()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Product Options"
          />

          <Row>
            <Col md={12}>
              {show == true ? (
                <Card className="p-4">
                  <Form
                    onSubmit={e => {
                      FormAddSubmit(e)
                    }}
                  >
                    <h5 className="mb-3">Create Product Option</h5>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label>Variation Name</Label>
                          <span className="text-danger">*</span>
                          <select
                            value={form.variationId}
                            name="variationId"
                            required
                            onChange={e => {
                              handleChange(e)
                            }}
                            className="form-select"
                          >
                            <option value="">Select</option>
                            {Category.map((data, key) => {
                              return (
                                <option key={key} value={data._id}>
                                  {data.name}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                      <Col md="6">
                        <Label>Name</Label>
                        <span className="text-danger">*</span>
                        <Input
                          onChange={e => {
                            handleChange(e)
                          }}
                          name="name"
                          value={form.name}
                          required
                          type="text"
                          placeholder="Enter Name"
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        onClick={() => {
                          setshow(!show)
                        }}
                        color="danger m-1"
                        className="btn-sm"
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        color="primary m-1"
                        className="btn-sm"
                      >
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              ) : (
                ""
              )}
            </Col>
            <Col md={12}>
              {show1 == true ? (
                <Card className="p-4">
                  <Form
                    onSubmit={e => {
                      FormEditSubmit(e)
                    }}
                  >
                    <h5 className="mb-3">Edit Product Option</h5>
                    <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label>Variation Name</Label>
                          <span className="text-danger">*</span>
                          <select
                            value={form1.variationId}
                            name="variationId"
                            required
                            onChange={e => {
                              handleChange1(e)
                            }}
                            className="form-select"
                          >
                            <option value="">Select</option>
                            {Category.map((data, key) => {
                              return (
                                <option key={key} value={data._id}>
                                  {data.name}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>
                      <Col md="6">
                        <Label>Name</Label>
                        <span className="text-danger">*</span>
                        <Input
                          required
                          name="name"
                          type="text"
                          value={form1.name}
                          placeholder="Enter Name"
                          onChange={e => {
                            handleChange1(e)
                          }}
                        />
                      </Col>
                    </Row>
                    <div className="text-end mt-4">
                      <Button
                        type="button"
                        onClick={() => {
                          setshow1(!show1)
                        }}
                        color="danger m-1"
                        className="btn-sm"
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                      <Button
                        type="submit"
                        color="primary m-1"
                        className="btn-sm"
                      >
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              ) : (
                ""
              )}
            </Col>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col>
                      <Button
                        onClick={() => navigate.goBack()}
                        className=""
                        style={{ float: "right" }}
                        color="primary"
                        size="sm"
                      >
                        <i className="far fa-arrow-alt-circle-left me-2"></i>
                        Back
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        color="primary "
                        onClick={() => {
                          AddPopUp()
                        }}
                        size="sm"
                      >
                        Create Product Option
                        <i className="bx bx-plus-circle"></i>
                      </Button>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          name="search"
                          value={form.search}
                          onChange={SearchData}
                          type="search"
                          placeholder="Search..."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr className="text-center">
                          <th>Sl.No</th>
                          <th>Name </th>
                          <th>Variant Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <th scope="row">
                              {(pageNumber - 1) * 5 + key + 6}
                            </th>
                            <td>{data.name}</td>
                            <td>{data.variationName}</td>
                            <td>
                              {data.status == "active" ? (
                                <>
                                  <b className="text-success">{data.status}</b>
                                </>
                              ) : (
                                <>
                                  <b className="text-danger">{data.status}</b>
                                </>
                              )}
                            </td>
                            <td>
                              {/* <Button
                                onClick={() => {
                                  UpdatePopUp(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="primary"
                                
                              >
                                <div className="d-flex"> */}
                              <i
                                className="bx bx-edit text-primary me-2 "
                                style={{
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  UpdatePopUp(data)
                                }}
                              ></i>
                              {/* </div>
                              </Button>
                              <Button
                                size="sm"
                                className="m-1"
                                color="primary"
                                onClick={() => {
                                  DeleteData(data)
                                }}
                                
                              >
                                <div className="d-flex"> */}
                              <i
                                className="bx bx-trash text-primary"
                                style={{
                                  fontSize: "22px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  DeleteData(data)
                                }}
                              ></i>
                              {/* </div>
                              </Button> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Col sm="12">
                      <div
                        className="d-flex mt-3 mb-1"
                        style={{ float: "right" }}
                      >
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default ProductOptions
